import React from 'react';
import styled from 'styled-components';

import ObjectId from 'bson-objectid';

import Admin from '../../components/Admin';
import getFilterWithCol from '../../helpers/getFilterWithCol';
import { getI18nFields } from '../../helpers/i18n';

import contentFields from './content';
import sliderFields from './slider';
import cardsFields from './cards';
import statsFields from './stats';
import buttonFields from './button';
import dividerFields from './divider';

const SECTION_TYPE_LIST = [
  { value: 'CONTENT', label: 'Content' },
  { value: 'SLIDER', label: 'Slider' },
  { value: 'CARDS', label: 'Cards' },
  { value: 'STATS', label: 'Stats' },
  { value: 'BUTTON', label: 'Button' },
  { value: 'DIVIDER', label: 'Divider' },
];

const SECTION_TYPE_LABELS_MAP = SECTION_TYPE_LIST.reduce(
  (agr, { value, label }) => {
    agr[value] = label;
    return agr;
  },
  {},
);

const SECTION_FIELDS = [
  Admin.compileFromLibrary(getFilterWithCol(['FieldReact', {
    virtual: [() => true],
    label: null,
    renderContent: (props) => {
      const typeLabel = SECTION_TYPE_LABELS_MAP[
        props.form.getFieldValue('type') || SECTION_TYPE_LIST[0].value
      ];
      return (
        <SectionTitle>
          {props.form.getFieldValue('name') || 'Section'}
          &nbsp;
          <SectionType>
            {`${typeLabel}`}
          </SectionType>
        </SectionTitle>
      );
    },
  }], 24)),
  Admin.compileFromLibrary(getFilterWithCol(['FieldText', {
    name: 'name',
    label: null,
    prefix: 'Name:',
  }], 12)),
  Admin.compileFromLibrary(getFilterWithCol(['FieldText', {
    name: 'id',
    label: null,
    prefix: 'ID:',
  }], 12)),
  Admin.compileFromLibrary(getFilterWithCol(['FieldSelect', {
    name: 'type',
    label: null,
    prefix: 'Type:',
    initialValue: 'CONTENT',
    choices: SECTION_TYPE_LIST,
  }], 12)),
  Admin.compileFromLibrary(getFilterWithCol(['FieldSelect', {
    name: 'show',
    label: null,
    prefix: 'Show:',
    initialValue: 'always',
    choices: [
      { value: 'always', label: 'Always' },
      { value: 'desktop', label: 'Desktop Only' },
      { value: 'mobile', label: 'Mobile Only' },
      { value: 'hidden', label: 'Hidden' },
    ],
  }], 12)),
  ...contentFields,
  ...sliderFields,
  ...cardsFields,
  ...statsFields,
  ...buttonFields,
  ...dividerFields,
];

const SectionTitle = styled.div`
  font-size: 20px;
  margin-top: 0px;
`;

const SectionType = styled.span`
  font-size: 14px;
  margin-top: 0px;
  padding-left: 5px;
  opacity: 0.6;
  /* vertical-align: middle; */
`;

// eslint-disable-next-line import/prefer-default-export
export function createField(sectionsPath = 'sections', config = {}) {
  return ['FieldSortableList', {
    name: sectionsPath,
    label: null,
    addButtonLabel: 'Add Section',
    supportDuplicate: true,
    collapseFieldName: '__collapsed',
    collapseLabelDefault: 'Section',
    getCollapseLabel: (props) => (
      <>
        {
          props.value[props.collapseLabelFieldName]
          || props.collapseLabelDefault
        }
        &nbsp;
        <SectionType>
          {`${SECTION_TYPE_LABELS_MAP[
            props.value.type || SECTION_TYPE_LIST[0].value
          ]}`}
        </SectionType>
      </>
    ),
    generateNewItem: () => ({
      _id: `${ObjectId()}`,
    }),
    getItemFields: getI18nFields,
    fields: [
      ...SECTION_FIELDS,
    ],
    ...config,
  }];
}
